import { callEndpoint } from ".";
import { Captin, listCaptinsRequest, listCaptinsResponse } from "../../../shared";
import { ENDPOINT_CONFIGS } from "../endpoints";

export const LOCAL_STORAGE_CAPTINS = 'captins';

export const setCaptinsLocally = async ()=>{ 
      const captins= await fetchCaptins();

      localStorage.setItem(LOCAL_STORAGE_CAPTINS, JSON.stringify(captins));
     
}

export const fetchCaptins = async (): Promise<Captin[]> =>{

  try{
  const res = await callEndpoint<listCaptinsRequest, listCaptinsResponse>(ENDPOINT_CONFIGS.listCaptins);

  return res.captins;
}catch(e)
{

  return [];
}
}



export const getCaptinsLocally = (): Captin[] => { 
  
  let captins:Captin[]=[{email:'',id:'0',name:'لايوجد'}]
 const captinsString = getLocalStorageCaptins();

  return captinsString? captins.concat(JSON.parse(captinsString)) : captins;
}

export const getLocalStorageCaptins = (): string => {
    return localStorage.getItem(LOCAL_STORAGE_CAPTINS) || '';
  };